import { CommonModule } from '@angular/common';
import { NgModule, inject } from '@angular/core';
import { SettingsCoreDataModule } from '@main/settings/settings-core-data.module';
import { ResolvedSettingFetcherService } from '@main/settings/services/resolved-setting-fetcher.service';

@NgModule({
  imports: [
    CommonModule,
    SettingsCoreDataModule,
  ],
})
export class SettingsCoreModule {
  constructor() {
    const settingFetcher = inject(ResolvedSettingFetcherService);
    const parentModule = inject(SettingsCoreModule, { optional: true, skipSelf: true });

    if (parentModule)
      throw new Error('SettingsCoreModule should only be loaded once');

    settingFetcher.start();
  }
}
